/** @module                             Components */

import Fieldset                         from "../../Global/Forms/Fieldset";

import { Input }                        from "../../Global/Forms/Inputs_Spread";

const 

Price = ( { __, state, action, loading } ) => {

    /** @returns Price component */

    return (

        <Fieldset legend={ __ ( "price" ) }>

            <Input

                type="text"

                label={ __ ( "price" ) }
                    
                value={ state.price } 

                action={ action }

                name={ "price" }

                disabled={ loading }
                
            />

        </Fieldset>

    );

}

/** @exports Price */
 
export default Price;